module.exports = __webpack_public_path__ + "img/no.902a33d0.svg";